import { EventEmitter, Injectable } from '@angular/core';
import { IBackNativeService } from './iback-native';

declare const backHeaderAndroid;

declare global {
    interface Window {
        webkit: any;
    }
}

@Injectable({ providedIn: 'root' })
export class BackNativeService implements IBackNativeService {


    backHeaderCommunicator(): void {
        /**
         * Send mensage for IOS or Android
         */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.backHeaderIOS) {
            this.comunicationIos();
        } else {
            this.comunicationAndroid();
        }
    }

    private comunicationIos() {
        window.webkit.messageHandlers.backHeaderIOS.postMessage({
            back: true
        });
    }

    private comunicationAndroid() {
        const param = {back: true};
        try {
            backHeaderAndroid.postMessage(param);
        } catch (error) {
        }
    }
}

